import {ContextMenu, ContextMenuOption} from "../../hook/useContextMenu";

//* Add id="context-menu-container" to upper level page container
//* const {menuVisible, menuPosition, handleContextMenu} = useContextMenu();
//* Add handleContextMenu={handleContextMenu} selectOnRightBtn to ReactTable
//* add menuVisible={menuVisible} menuPosition={menuPosition} to ContextMenuComposed props
//*add prop notInContextMenu or "data-notincontextmenu" to btn to exclude from ContextMenu

const ContextMenuComposed = ({className, style, menuVisible, menuPosition, children}) => {
  const makeContextMenuOptionFromChild = child => {
    return (
      <ContextMenuOption
        key={child.props.name || child.key}
        text={child.props.name || child.key}
        onClick={child.props.onClick}
        disabled={child.props.disabled}
        // hidden={child.props.hidden}
        btnClassName={child.props.className}
        uiPermissionType={child.props.uiPermissionType}
      />
    );
  };

  return (
    <>
      <ContextMenu menuVisible={menuVisible} menuPosition={menuPosition}>
        {(Array.isArray(children) ? children : [children])
          ?.map(child => {
            if (!child || child.props.notInContextMenu || child.props["data-notincontextmenu"]) return;

            //upper level btns
            if (child.props.onClick) {
              return makeContextMenuOptionFromChild(child);
            }

            //children level btns
            if (Array.isArray(child.props.children)) {
              if (!child.props.children.find(innerChild => innerChild.props.onClick)) return;

              return child.props.children?.map(innerChild => {
                if (
                  !innerChild.props.onClick ||
                  innerChild.props.notInContextMenu ||
                  innerChild.props["data-notincontextmenu"]
                )
                  return;
                return makeContextMenuOptionFromChild(innerChild);
              });
            }
            if (
              child.props.children &&
              !Array.isArray(child.props.children) &&
              !child.props.children.notInContextMenu &&
              !child.props.children.props["data-notincontextmenu"] &&
              child.props.children.props.onClick
            ) {
              return makeContextMenuOptionFromChild(child.props.children);
            }

            return;
          })
          ?.filter(child => child !== undefined)}
      </ContextMenu>

      <div className={className} style={style}>
        {children}
      </div>
    </>
  );
};

export default ContextMenuComposed;
